import React, { useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { useSnackbar } from "notistack";

export default function EmailApplyModal({ jobid }) {
  const { register, handleSubmit, errors, reset } = useForm();
  const { enqueueSnackbar } = useSnackbar();

  const easyApplySubmit = (value) => {
    let submitButton = document.querySelector("#easyApplySubmit");
    submitButton.setAttribute("disabled", "disabled");
    submitButton.innerText = "Submitting....";

    let cv = value.cv[0];
    delete value.cv;
    const formData = new FormData();
    Object.keys(value).map((key) => {
      formData.append(key, value[key]);
    });
    formData.append("cv", cv);

    axios.post("/api/jobs/easy-apply", formData).then((response) => {
      enqueueSnackbar(response.data.message, { variant: response.data.status });
      if (response.data.status == "success") {
        reset();
        $("#easy_apply_popup").modal("hide");
      }
    });
    submitButton.innerText = "Easy Apply";
    submitButton.removeAttribute("disabled");
  };

  return (
    <div
      className="modal fade twm-sign-up"
      id="easy_apply_popup"
      aria-hidden="true"
      aria-labelledby="easy_apply_popupLabel"
      tabindex="-1"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <form onSubmit={handleSubmit(easyApplySubmit)}>
            <div className="modal-header">
              <h2 className="modal-title" id="easy_apply_popupLabel">
                Email Apply
              </h2>
              <p>Feel free to Easy Apply with Nokari Job.</p>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>

            <div className="modal-body">
              <div className="row">
                <div className="col-lg-12">
                  <div className="form-group mb-3">
                    <input
                      type="hidden"
                      name="jobid"
                      value={jobid}
                      ref={register()}
                    />
                    <input
                      name="full_name"
                      type="text"
                      placeHolder="Full Name *"
                      className={`form-control ${
                        errors.full_name !== undefined ? "is-invalid" : ""
                      }`}
                      ref={register({
                        required: "Please enter your fullname.",
                      })}
                    />
                    {errors.full_name && (
                      <div id="full_nameFeedback" className="text-danger">
                        {errors.full_name.message}
                      </div>
                    )}
                  </div>
                </div>

                <div className="col-lg-12">
                  <div className="form-group mb-3">
                    <input
                      name="email"
                      type="text"
                      placeHolder="Email *"
                      className={`form-control ${
                        errors.email !== undefined ? "is-invalid" : ""
                      }`}
                      ref={register({
                        required: "Please enter your email address.",
                        pattern: {
                          value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                          message: "Invalid email address.",
                        },
                      })}
                    />
                    {errors.email && (
                      <div id="emailFeedback" className="text-danger">
                        {errors.email.message}
                      </div>
                    )}
                  </div>
                </div>

                <div className="col-lg-12">
                  <div className="form-group mb-3">
                    <input
                      name="contact_number"
                      type="number"
                      id="contact_number"
                      className={`form-control ${
                        errors.contact_number !== undefined ? "is-invalid" : ""
                      }`}
                      placeholder="Contact Number *"
                      ref={register({
                        required: "Please enter your contact number.",
                        minLength: {
                          value: 10,
                          message: "Contact number must be 10 digits long.",
                        },
                        maxLength: {
                          value: 10,
                          message: "Contact number must be 10 digits long.",
                        },
                      })}
                    />
                    {errors.contact_number && (
                      <div id="contact_numberFeedback" className="text-danger">
                        {errors.contact_number.message}
                      </div>
                    )}
                  </div>
                </div>

                <div className="col-lg-12">
                  <div className="form-group mb-3">
                    <textarea
                      name="cover_letter"
                      rows="5"
                      placeHolder="Cover Letter"
                      className={`form-control ${
                        errors.cover_letter !== undefined ? "is-invalid" : ""
                      }`}
                      ref={register()}
                    ></textarea>
                    {errors.cover_letter && (
                      <div id="cover_letterFeedback" className="text-danger">
                        {errors.cover_letter.message}
                      </div>
                    )}
                  </div>
                </div>

                <div className="col-lg-12">
                  <div className="form-group mb-3">
                    <div
                      class="ls-inputicon-box file-upload-wrapper"
                      data-text="Upload CV"
                      title="Upload Your CV"
                    >
                      <input
                        name="cv"
                        type="file"
                        className={`file-upload-field form-control-file ${
                          errors.cv !== undefined ? "is-invalid" : ""
                        }`}
                        ref={register({
                          required: "Please upload your CV.",
                        })}
                      />
                    </div>
                    {errors.cv && (
                      <div id="fileFeedback" className="text-danger">
                        {errors.cv.message}
                      </div>
                    )}
                  </div>
                </div>

                <div className="col-md-12">
                  <button
                    type="submit"
                    className="site-button"
                    id="easyApplySubmit"
                  >
                    Easy Apply
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
